module.exports = __webpack_public_path__ + "static/c6484866-db3d-42a2-b0b7-9734896f2e73-bf1a5ebe0f935b98b6a76f21d8e1d0c7.jpeg";